module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/prod-07-1452385a51f4a0bf0c5c3c0832fbc81b.jpg";